import React from "react";
import Modal from "react-bootstrap/Modal";
import { useModalWrapper } from "./ModalWrapperProvider";

function ModalWrapper() {
    const { modal, hideModal } = useModalWrapper();
    return (
        <Modal show={modal.show} size={modal.size} onHide={hideModal}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            keyboard={false}
            centered
            style={{overflow: "scroll"}}>
            <Modal.Header>
                {modal.title && <Modal.Title>{modal.title}</Modal.Title>}
            </Modal.Header>

            <Modal.Body className="pt-0 pb-15">
                {modal.body}
            </Modal.Body>

            {modal.buttons &&
                <Modal.Footer>
                    {modal.buttons}
                </Modal.Footer>
            }
        </Modal>
    )
}

export default ModalWrapper;
